import styled from '@emotion/styled';

import { spacing, borderRadius, typography } from '../tokens';

// ─── Root: [ pill ] ┊ texto ───────────────────────────────────────────────────

export const NoteRoot = styled('div')`
  display: flex;
  align-items: center;
  gap: ${spacing.lg};
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing.md} 0;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.sm};
  }
`;

// ─── Pill de status (contorno) ────────────────────────────────────────────────

export const StatusPill = styled('span', {
  shouldForwardProp: (p) => !p.toString().startsWith('$'),
})<{ $bg: string; $border: string; $text: string }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.sm} ${spacing.md};
  border: 1px solid ${({ $border }) => $border};
  border-radius: ${borderRadius.full};
  background: ${({ $bg }) => $bg};
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.extraBold};
  color: ${({ $text }) => $text};
  white-space: nowrap;
`;

// ─── Divisor tracejado vertical (Figma: dash 2,2, #262626) ────────────────────

export const DottedDivider = styled('span')`
  align-self: center;
  flex-shrink: 0;
  width: 1px;
  min-height: 34px;
  border-right: 1px dashed #262626;
  margin: 0 ${spacing.xs};

  @media (max-width: 600px) {
    display: none;
  }
`;

// ─── Bloco de texto ───────────────────────────────────────────────────────────

export const TextBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
`;

export const NoteTitle = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.extraBold};
  line-height: 1.35;
  color: #262626;
`;

export const NoteDescription = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.regular};
  line-height: 1.35;
  color: #262626;
`;
